export const DATES_FORMAT = 'MMM d, u';
export const DATE_FORMAT_FULL_MONTH_DAY_YEAR = 'MMMM DD, YYYY';
export const DATE_FORMAT_MONTH_DAY_YEAR = 'MMM DD, YYYY';
export const EXPORT_FORMAT = 'yyyy-MM-dd';
export const ONE_MEGABYTE = 1000000;
export const DATE_FORMAT_WITH_HOUR = 'MMM d, u HH:MM:SS';
export const DATE_AND_HOUR = 'yyyy-MM-dd_HH-mm-ss';
